import Types from './ActionTypes';

const setLoaded = (loaded: boolean) => {
  return (dispatch: any) => dispatch(Types.SetLoaded(loaded));
};

export default { setLoaded };
